import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  loading = false;
  sesion = false;
  message = '';

  logoCidi = 'assets/img/cidi.png';

  cidiUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.cidi.url);

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    public _auth: AuthenticationService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {

    this._route.params.subscribe(param => {
      if (param.hash) {
        this.login(param);
      } else {
        this.message = 'Se produjo un error en la redirección de CIDI, puede volver a intentar con el siguiente botón';
        this.sesion = true;
        this.loading = true;
      }
    });
  }

  login(param) {

    this._auth.loginExternal(param).subscribe(data => {
      if (param.name == 'cidi') {
        localStorage.setItem('CiDi', param.hash);
      }
      this._router.navigate(['/pages']);
    }, error => {
      if (error.code == 400) {
        this.message = 'El usuario ingresado no tiene permisos para hacer uso de esta aplicación.';
      } else {
        this.message = 'No hemos podido conectar con el servicio FTAgo, intentelo nuevamente mas tarde.';
      }
      this.loading = true;
    });

  }

  returnLogin() {
    this._router.navigate(['/login']);
  }

}
